// The events the grid's controllers talk over. Views name some of them too (data-action and
// turbo_stream_broadcast_event); grid_events.test.js checks those spellings against these.
export const GRID_EVENTS = {
  setUploadId: 'ag-grid:set-upload-id',
  updateCellValue: 'ag-grid:update-cell-value',
  modalOperationStarted: 'ag-grid:modal-operation-started',
  modalOperationCompleted: 'ag-grid:modal-operation-completed',
  parsed: 'grid:parsed',
  cellsClassified: 'grid:cells-classified',
  cellResolved: 'grid:cell-resolved',
  revealCell: 'grid:reveal-cell',
  decideCell: 'grid:decide-cell',
  decisionConfirmed: 'grid:decision-confirmed',
  reviewCounts: 'grid:review-counts'
}

// TempServiceRecord's resolution values (grid_events.test.js checks them against the model's enum).
export const RESOLUTIONS = {
  update: 'update',
  delete: 'delete',
  skipped: 'skipped',
  noOp: 'no_op'
}
